import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import 'devbridge-autocomplete';
import app from "../../../general/js/app";
import api from "../../../general/js/api";
import axios from "axios";

export default class PredictiveSearch extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            query: '',
            queryType: ''
        };
        this.isBindedToProps = ('query' in props);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleContentChange = this.handleContentChange.bind(this);
        this.inputRef = this.inputRef.bind(this);
        this.formRef = this.formRef.bind(this);

        this.baseElement = null;
        this.inputElement = null;
        this.lastRequestCancel = null;
        this.predictiveSearchUrl = app.getConfig('predictiveSearchUrl');
        this.maxToShow = app.getConfig('predictiveSearchMaxItemsToShow');
        this.moreSuggestionsAvailableClass = 'more-suggestions-available';

    }

    componentDidMount() {
        this.$inputElement = $(this.inputElement);

        this.autocompleteInstance = this.$inputElement.devbridgeAutocomplete({
            groupBy: 'group',
            minChars: 3,
            deferRequestBy: 300,
            zIndex: 30,
            appendTo: this.baseElement,
            showNoSuggestionNotice: true,
            noSuggestionNotice: 'No results found!',
            triggerSelectOnValidInput: false,
            lookup: (query, done) => {

                if (this.lastRequestCancel) {
                    this.lastRequestCancel();
                    this.lastRequestCancel = null;
                }

                let CancelToken = axios.CancelToken;
                let source = CancelToken.source();
                this.lastRequestCancel = source.cancel.bind(source);

                this.spinnerElement.classList.add('is-loading');
                api.get(this.predictiveSearchUrl, {
                    params: {input: query},
                    cancelToken: source.token
                }).then(({data}) => {
                    if (data.total > this.maxToShow) {
                        this.baseElement.classList.add(this.moreSuggestionsAvailableClass);
                    } else {
                        this.baseElement.classList.remove(this.moreSuggestionsAvailableClass);
                    }
                    done({suggestions: data.results});
                }, (error) => {
                    if (axios.isCancel(error)) {
                        console.log('Request canceled', error.message);
                    } else {
                        console.error(error);
                    }
                }).finally(() => {
                    this.lastRequestCancel = null;
                    this.spinnerElement.classList.remove('is-loading');
                });
            },
            onSelect:
                (suggestion) => {
                    this.handlePredictiveSelect(suggestion);
                }
        }).devbridgeAutocomplete();
        this.autocompleteInstance.suggestionsContainer.setAttribute('data-max-to-show', this.maxToShow);

        if (this.isBindedToProps) {
            this.setState({
                query: this.props.query,
                queryType: this.props.queryType,
            });
        }
    }

    componentWillUnmount() {
        this.autocompleteInstance.dispose();
    }

    componentWillReceiveProps(nextProps) {
        if (this.isBindedToProps) {
            this.setState({
                query: nextProps.query,
                queryType: nextProps.queryType,
            })
        }
    }

    formRef(el) {
        if (el) {
            this.baseElement = el.parentElement;
        }
    }

    inputRef(el) {
        this.inputElement = el;
        if (this.props.inputRef) {
            this.props.inputRef(el);
        }
    }

    render() {
        return (
            <form ref={this.formRef}
                  className={`predictive-search ${this.props.isListing ? 'predictive-search--listing' : ''}`}
                  onSubmit={this.onSubmit}>
                <input onChange={this.handleContentChange} value={this.state.query}
                       ref={this.inputRef}
                       placeholder="lot no, postcode, address..."
                       className={`predictive-search__input ${this.props.inputClass}`} type="text"/>
                <input type="hidden" value={this.state.queryType}/>

                <div className="predictive-search__spinner spinner" ref={el => this.spinnerElement = el}>
                </div>

                {this.props.isListing ?
                    <button type="submit" className="predictive-search__submit">
                        <span>
                            <svg className="icon" width="14" height="14">
                                <use xlinkHref="#icon-search"></use>
                            </svg>
                        </span>
                    </button> : null}
            </form>
        );
    }

    handleContentChange(e) {
        let value = e.target.value;
        this.setState({
            query: value,
            queryType: '',
        });
    }

    onSubmit(e) {
        e.preventDefault();
        this.handleSubmit(this.state.query, this.state.queryType);
    }

    handlePredictiveSelect(suggestion) {
        if (suggestion.data.url) {
            window.location.href = suggestion.data.url;
        } else {
            this.handleSubmit(suggestion.value, suggestion.data.type);
        }
    }

    handleSubmit(query, queryType) {
        this.props.onChange({
            query: query,
            queryType: queryType,
        });
    }
}

PredictiveSearch.defaultProps = {
    inputClass: '',
    isListing: false,
};

PredictiveSearch.propTypes = {
    query: PropTypes.string,
    queryType: PropTypes.string,
    inputRef: PropTypes.func,
    inputClass: PropTypes.string,
    isListing: PropTypes.bool,
};




// WEBPACK FOOTER //
// ./app/components/predictive-search/js/PredictiveSearch.js